import { FCX, getRem, useOutsideClick } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { FiSearch } from "react-icons/fi";
import TextInput from "@components/TextInput";
import { useSelectFilters } from "@vms/SelectFilters/SelectFiltersContext";
import SlashSelect from "@components/SlashSelect";
import { useCallback, useMemo, useRef, useState } from "react";
import { useCommonDataContext } from "@core/CommonDataContext";
import Dropdown from "@components/Dropdown/Dropdown";

const SearchForFilters: FCX = ({
   className,
   testId,
}) => {
	const dropdownRef = useRef(null);
	const [isOpened, setIsOpened] = useState<boolean>(false)
	const { categories } = useCommonDataContext();
	const {
		search,
		setSearch,
		expandedCategories,
		setExpandedCategories,
		dropdownGroups,
	} = useSelectFilters();

	const openDropdown = useCallback(() => setIsOpened(true), [])
	const closeDropdown = useCallback(() => setIsOpened(false), [])

	useOutsideClick({
		ref: dropdownRef,
		callback: closeDropdown,
		isDisabled: !isOpened,
	});

	const allCategoriesIds = useMemo(() => categories?.map(i => i.id ?? 0) ?? [], [categories])

	const handleExpand = useCallback((isExpanding: boolean) => () => {
		setExpandedCategories((prevExpanded) => {
			if (prevExpanded.length === 0) {
				return allCategoriesIds;
			}

			if (prevExpanded.length === allCategoriesIds?.length) {
				return [];
			}

			return isExpanding ? allCategoriesIds : [];
		});
	}, [allCategoriesIds, setExpandedCategories]);


	const slashSelectData = useMemo(() => {
		return [
			{
				title: "Expand All",
				isActive: expandedCategories.length === categories?.length,
				onClick: handleExpand(true),
			},
			{
				title: "Collapse All",
				isActive: expandedCategories.length === 0,
				onClick: handleExpand(false),
			},
		];
	}, [expandedCategories, handleExpand, categories?.length]);

	return (
		<div
			className={
				cn(
					"SearchForFilters",
					className,
				)
			}
			ref={dropdownRef}
			data-testid={testId}
			onClick={openDropdown}
		>
			<TextInput
				className="SearchForFilters__search"
				tooltipId="search-for-filters"
				placeholder="Search"
				modifiers={["transparent"]}
				suffix={<FiSearch/>}
				value={search}
				setValue={setSearch}
				testId="blockSearchForFilters"
			/>
			<Dropdown
				id="search-for-filters"
				className="SearchForFilters__dropdown SearchForFiltersDropdown"
				tooltipId="search-for-filters"
				groups={dropdownGroups}
				testId="blockSearchForFiltersDropdown"
				place="bottom-end"
				isInPortal={false}
				isOpened={search.trim().length > 0 && isOpened}
				style={{ width: getRem(300) }}
			>
			</Dropdown>
			<SlashSelect
				className="SearchForFilters__slash-select SearchForFiltersSlashSelect"
				data={slashSelectData}
				testId="blockFiltersExpandCollapse"
			/>
		</div>
	);
};

export default SearchForFilters;